import React, { useRef, useState } from "react";
import { MediaField } from "../practiceGuide/components/MediaField";

export function AlbumMediaUpload({ onMetadata, uploadFn, media }) {
  return (
    <>
      <MediaField
        label="Cover Image"
        name="coverImage"
        type="image"
        src={media?.coverImage?.src}
        height={142}
        accept="image/*"
        uploadFn={uploadFn}
      />

      <MediaField
        label="Introduction Video"
        name="introVideo"
        type="video"
        src={media?.introVideo?.src}
        height={320}
        accept="video/*"
        uploadFn={uploadFn}
        onMetadata={onMetadata}
      />
    </>
  );
}
